<template>
    <div id="nissan-quiz-notreadytoplay-ipad" class="nissan-quiz-screen">
        <img class="trivia-logo" src="./../assets/quizz_logo.png" />
        <div class="text-block">
            <p class="large"><i>It’s time to test your knowledge of</i></p>
            <p class="larger"><i>Nissan Intelligent Mobility!</i></p>
            <p>Answer as many questions correct as you can to win. Do it in the fastest time, and you could win big!</p>
        </div>
        <div class="disclaimer">
            To claim your prize you must be 18 years of age and present in the Nissan booth during the game.
        </div>
    </div>
</template>

<script>
export default {
  name: 'Intro',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "./../styles/_global.scss";
    @import "./../styles/_variables.scss";
    .text-block {
        font-size: 14px;
        text-align: center;
        margin: 60px 90px 0;
    }
</style>
